import { THEME_MAP, ThemeName } from '@shared/styled-system/theme';

import { config } from '@/config.ts';

export const useCustomTheme = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const themeParam = urlParams.get('brand') as ThemeName | null;

	if (themeParam && themeParam in THEME_MAP) {
		if (themeParam === 'custom' && config.ENV !== 'development') {
			return THEME_MAP.default;
		}
		return THEME_MAP[themeParam];
	}

	const envTheme = config.BRAND_THEME as ThemeName | undefined;
	if (envTheme && envTheme in THEME_MAP) {
		return THEME_MAP[envTheme];
	}

	return THEME_MAP.default;
};
